module.exports = __webpack_public_path__ + "img/jeux-coquins.6325c6dd.jpg";